import { useEffect } from "react";
import { useFileStore } from "../../../../store/useFileStore";

const DocChartsCategoryJson = () => {
    // eslint-disable-next-line no-unused-vars
    const [_, setStore] = useFileStore((store) => store);

    useEffect(() => {
        let value = `{
    "label": "Charts",
    "position": 6,
    "collapsible": false,
    "collapsed": false
}`;

        setStore({ docChartsCategoryJson: value });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};

export default DocChartsCategoryJson;
